import { createSlice } from '@reduxjs/toolkit';
import { SupplierBranch } from '@dill/dill-shared';
import {
  getSupplierBranchesExtraReducer,
  updateSupplierBranchesExtraReducer,
} from '../reducers/supplierAdditionalDetailsReducers';

export interface SupplierBranchesInitialState {
  loadingList: string[];
  error: string | null;
  branches: SupplierBranch[];
  // The supplierId `branches` was last fetched for, so consuming components can tell a stale
  // fetch (from a previously viewed supplier) apart from a fresh one and refetch when the
  // current supplier changes, instead of trusting a `branches` array left over from another
  // supplier.
  loadedSupplierId: string | null;
}

const initialState: SupplierBranchesInitialState = {
  loadingList: [],
  error: null,
  branches: [],
  loadedSupplierId: null,
};

export const supplierBranchesSlice = createSlice({
  name: 'supplierBranches',
  initialState,
  reducers: {
    resetSupplierBranchesRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierBranchesExtraReducer(builder);
    updateSupplierBranchesExtraReducer(builder);
  },
});

export const { resetSupplierBranchesRootState } = supplierBranchesSlice.actions;
